module.exports = __webpack_public_path__ + "static/media/logo.98762485.png";